function Error() {

    return (
        <div>
            <h1>Oups 🙈 this page doesn't exists</h1>
        </div>
    )
}

export default Error